import React from "react";

import { Button } from "../../../atoms/Buttons/Base";
import { Text } from "../../../atoms/Text/Text";
import { FriendPopupType } from "../../../models/Enums";
import { MaxCounter } from "../FriendBlockUserAuthorized";
import classNames from "classnames";
import styles from "./SendInvitePopup.css";

type MaxCounterToReceivePopupProps = {
  onClose: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onLoadContent: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  popupType: FriendPopupType;
  error?: number;
};

export class MaxCounterToReceivePopup extends React.Component<MaxCounterToReceivePopupProps> {
  static displayName = "MaxCounterToReceivePopup";

  componentDidMount() {
    this.props.onLoadContent(null);
  }

  handleErrorPopup = () => {
    switch (this.props.error) {
      case 503:
        return (
          <React.Fragment>
            <Text
              bold={true}
              size="xl"
              margin="0 0 16px 0"
              className={styles.coverTitleInfo}
              align="center"
            >
              Oops! After this invitation was sent to you, your friend's Private
              Friends Network <br /> reached its limit of 150 friends. Your
              friend is popular! <br /> Let them know to make some room for you,{" "}
              <br /> and then you can join their network.
            </Text>
            <Button
              onClick={this.props.onClose}
              className={classNames(
                styles.buttonYesNoLong,
                styles.buttonFriend
              )}
            >
              <Text bold={true} size="sm" style={{ padding: "5px" }}>
                Got it
              </Text>
            </Button>
          </React.Fragment>
        );

      case 504:
        return (
          <React.Fragment>
            <Text
              bold={true}
              size="xl"
              margin="0 0 16px 0"
              className={styles.coverTitleInfo}
              align="center"
            >
              Oops! Your Private Friends Network has reached its limit of 150
              friends. You're popular! <br />
              Make some room and then you can accept this friend's invitation.
            </Text>
            <Button
              onClick={this.props.onClose}
              className={classNames(
                styles.buttonYesNoLong,
                styles.buttonFriend
              )}
            >
              <Text bold={true} size="sm" style={{ padding: "5px" }}>
                Got it
              </Text>
            </Button>
          </React.Fragment>
        );
      default:
        return null;
    }
  };

  render() {
    return this.handleErrorPopup();
  }
}
